module.exports = __webpack_public_path__ + "img/blog-1.769650a6.png";